import { type ReactNode } from 'react';
import styles from './FormGroup.module.css';

interface FormGroupProps { label: string; hint?: string; children: ReactNode; }

export function FormGroup({ label, hint, children }: FormGroupProps) {
  return (
    <div className={styles.group}>
      <label className={styles.label}>{label}</label>
      {children}
      {hint && <span className={styles.hint}>{hint}</span>}
    </div>
  );
}

export function FormInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className={styles.input} {...props} />;
}

export function FormSelect({ children, ...props }: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={styles.select} {...props}>{children}</select>;
}

export function FormTextarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={styles.textarea} {...props} />;
}
